import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  heading: {
    id: 'addTowingRecord.heading',
    defaultMessage: 'Uusi kuormakirja',
  },
  vehicleHeading: {
    id: 'addTowingRecord.vehicleHeading',
    defaultMessage: 'Ajoneuvo',
  },
  registrationNumber: {
    id: 'addTowingRecord.registrationNumber',
    defaultMessage: 'Rekisteritunnus',
  },
  exportToWaybill: {
    id: 'addTowingRecord.exportToWaybill',
    defaultMessage: 'Vie kuormakirjalle',
  },
  makeAndModel: {
    id: 'addTowingRecord.makeAndModel',
    defaultMessage: 'Merkki ja malli',
  },
  insuranceCompany: {
    id: 'addTowingRecord.insuranceCompany',
    defaultMessage: 'Vakuutusyhtiö',
  },
})
